import { AmplitudeMetadataContextProvider } from '../../support/amplitude/AmplitudeMetadataContext';

interface LabMetadataContextProps {
  trackId: string;
  trackSkippable: boolean;
  inviteId?: string;
  participantId: string; // only available once track is started by user
  isHotStarted: boolean; // only available once track is started by user
  mode: string;
  isInIframe: boolean;
  teamSlug: string;
  fullScreenSupported?: boolean;
  numberOfChallenges: number;
  timeLimit: number;
  medianStartTime: number;
  idleTimeout: number;
  inInspectMode?: boolean;
  viewportSize: string;
  screenSize: string;
  children: React.ReactNode;
}

export const LabMetadataContext = ({ children, ...props }: Partial<LabMetadataContextProps>) => {
  return <AmplitudeMetadataContextProvider metadata={props}>{children}</AmplitudeMetadataContextProvider>;
};
